// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getPartnerUsers() {
            const response = await axios.get(`${MAIN_API}/api/partner/users`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async createUser(_, data) {
            const response = await axios.post(`${MAIN_API}/api/partner-category-job/create`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async deleteUser(_, id) {
            const response = await axios.delete(`${MAIN_API}/api/partner/users/` + id, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getJobsHistory() {
            const response = await axios.get(`${MAIN_API}/api/user-car/service-history-jobs/default`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getPartnerCategories() {
            const response = await axios.get(`${MAIN_API}/api/category/partner`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
    }
}
